module.exports = __webpack_public_path__ + "media/images/icons/duotoneicons/Home/Lamp#1-e0880421bc3cbd0565e66da24f1b320247ae5f2d374ec2cdbd1817e0b148f2c1.svg";